import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const PrivacyPolicyFooter = () => {
    const { t } = useTranslation();
    return (
        <div className="small-text text-center ml-auto mr-auto max-400">
            <p>{t("You acknowledge that you read, and agree to our")} <Link to="/page/terms-of-services">{t("Terms of Use")}</Link> {t("and our")} <Link to="/page/privacy-policy">{t("Privacy Policy")}</Link></p>
        </div>
    );
};

export default PrivacyPolicyFooter;
